import { render, staticRenderFns } from "./ParallelogramB.vue?vue&type=template&id=639e8b2c&scoped=true"
import script from "./ParallelogramB.vue?vue&type=script&lang=js"
export * from "./ParallelogramB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e8b2c",
  null
  
)

export default component.exports